import React from 'react';
import formatSecondsShort from 'utils/formatSecondsShort';
import classNames from 'classnames';
import './CommentPopover.styl';
import CallHistoryActions from 'actions/inbox/CallHistoryActions';
import chopAtWordBoundary from 'utils/chopAtWordBoundary';
import {stripHtmlWithSpaces} from 'utils/stripHtml';
import {htmlDecode} from 'components/triggers/BulletedMatchedRuleDescription';

export default function CommentPopover({items}) {
  return (
    <div>
      <h2 className="popover-header">Comments</h2>
      {items
        .sortBy(item => item.context.location)
        .map(item => (
          <div
            className={classNames(
              'history-action-item',
              'comment-item',
              item.context.active ? '' : 'disabled'
            )}
            key={item.id}
            onMouseEnter={() =>
              item.context.active && CallHistoryActions.hoverComment(item.context.id)
            }
            onMouseOut={() => item.context.active && CallHistoryActions.unhoverComment()}>
            <div className="timestamp">{formatSecondsShort(item.context.location)}</div>{' '}
            {displayText(item.context.reason)}
          </div>
        ))}
    </div>
  );
}

function displayText(text) {
  if (text === '<deleted>') {
    return text;
  } else {
    return chopAtWordBoundary(htmlDecode(stripHtmlWithSpaces(text)), 40);
  }
}
